import React, { Component } from 'react';
import { VideoSection } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The watch Taggis in action section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
class WatchTaggisView extends Component {

	render () {
		const { heading, heading1, heading2, videoId } = this.props.content.landingPage.watchTaggis;

		return (
			<VideoSection
				{...{
					heading,
					heading1,
					heading2,
					videoId,
				}}
				className='WatchTaggisView'
			/>
		);
	}

}

export default withLanguageContext(WatchTaggisView);



// WEBPACK FOOTER //
// ./src/components/views/WatchTaggisView/WatchTaggisView.js